import { env } from '../../config/env'

let loader: Promise<void> | null = null

export function loadGoogleMaps() {
  if (typeof google !== 'undefined' && google.maps) return Promise.resolve()
  if (loader) return loader
  if (!env.googleMapsKey) return Promise.reject(new Error('VITE_GOOGLE_MAPS_KEY is required.'))
  loader = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(env.googleMapsKey)}&language=ar&region=SY`
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => { loader = null; reject(new Error('Google Maps failed to load.')) }
    document.head.appendChild(script)
  })
  return loader
}
